import React from 'react';
import {view} from '@sail/ui';

const basic = {
  rendered: (
    <view.span
      css={{
        font: 'body',
        fontWeight: 'semibold',
        color: 'success',
        marginY: 'large',
      }}
    >
      This is an example of the inline component.
    </view.span>
  ),
  source: `<Inline
  css={{
    font: 'body',
    fontWeight: 'semibold',
    color: 'success',
    marginY: 'large',
  }}
>
  This is an example of the inline component.
</Inline>`,
};

const boldText = {
  rendered: (
    <view.span css={{font: 'body', color: 'primary', fontWeight: 'semibold'}}>
      This text is emphasized
    </view.span>
  ),
  source: `<Inline css={{font: 'body', color: 'primary', fontWeight: 'semibold'}}>
  This text is emphasized
</Inline>`,
};

const secondaryText = {
  rendered: (
    <view.span css={{font: 'caption', color: 'secondary'}}>
      This text is styled using the caption text style and the secondary color.
    </view.span>
  ),
  source: `<Inline css={{font: 'caption', color: 'secondary'}}>
  This text is styled using the caption text style and the secondary color.
</Inline>`,
};

export const InlineExamples = {basic, secondaryText, boldText};
